var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{attrs:{"clsas":"section_img"}},[_c('img',{attrs:{"src":_vm.topMenu.img}})]),_c('div',{staticClass:"section_text"},[_c('h2',[_vm._v(_vm._s(_vm.topMenu.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }